﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../../utilities/crud-functions';
import { HplcMassSpecCalculator } from '../../models/Calculators/hplc-mass-spec-calculator';
import { FieldUpdate } from '../../models/field-update';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { NameNumericalValue } from '../../models/Calculators/name-numerical-value';
import { ModalMessageType } from '../../models/enums';
import { IdentityByHplcMassSpec } from '../../models/Calculators/identity-by-hplc-mass-spec';
import { HplcMassSpecOverlabeledDistribution } from '../../models/Calculators/hplc-mass-spec-overlabeled-distribution';
import { HplcMassSpecCalculation } from '../../models/Calculators/hplc-mass-spec-calculation';
import HplcCalculationDetails from '../Documentation/HplcCalculationDetails';

//import { IdentityByHplcMassSpecRequest } from '../../models/Calculators/identity-by-hplc-mass-spec-request';
//import { HplcMassSpecOverlabeledDistributionRequest } from '../../models/Calculators/hplc-mass-spec-overlabeled-distribution-request';

import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    Selection,
    Summary,
    TotalItem,
} from 'devextreme-react/data-grid';

import HtmlEditor from 'devextreme-react/html-editor';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import Button from 'devextreme-react/button';

let key = 0;

export default function HplcMassSpecCalculatorForm() {
    const [calculator, setCalculator] =
        useState<HplcMassSpecCalculator>();

    const [calculation, setCalculation] =
        useState<HplcMassSpecCalculation>();

    const [identityResults, setIdentityResults] =
        useState<NameNumericalValue[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    const parts = window.location.href.split('/');
    const calculatorId = parts[parts.length - 1];

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        assembleHplcCalculationResults();
    }, [calculation]);

    useEffect(() => {
        updateAreaValuesArray();
    }, [calculator && calculator.areaValuesString]);

    key++;

    const distributionLabel = () => {
        return `${calculation && calculation.hplcMassSpecOverlabeledDistributionResult && calculation.hplcMassSpecOverlabeledDistributionResult.isOverlabeled ? "Overlabeled " : ""}Distribution`;
    }

    const actualMassPassFail = () => {
        if (calculation && calculation.identityByHplcMassSpecResult && calculation.identityByHplcMassSpecResult.lowerLimit &&
            calculation.identityByHplcMassSpecResult.upperLimit) {
            if (calculator.actualMass < calculation.identityByHplcMassSpecResult.lowerLimit ||
                calculator.actualMass > calculation.identityByHplcMassSpecResult.upperLimit)
                return <div className="pw-bold pw-red">Actual Mass FAIL</div>;

            else
                return <div className="pw-bold pw-green">Actual Mass PASS</div>;

        }
        else
            return <div className="pw-bold">Actual Mass Pass/Fail indeterminant</div>;
    }

    const massErrorPassFail = () => {
        if (calculation && calculation.identityByHplcMassSpecResult.actualMassError && calculation.identityByHplcMassSpecResult.lowerLimit &&
            calculation.identityByHplcMassSpecResult.upperLimit) {
            if (calculation.identityByHplcMassSpecResult.actualMassError < -5 ||
                calculation.identityByHplcMassSpecResult.actualMassError > 5)
                return <div className="pw-bold pw-red">Mass Error FAIL</div>;

            else
                return <div className="pw-bold pw-green">Mass Error PASS</div>;

        }
        else
            return <div className="pw-bold">Mass Error Pass/Fail indeterminant</div>;
    }


    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">HPLC Mass Spec Calculator</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-bg-rb-100">
                <div className="pw-comp-row pw-margin-top-1">
                    <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">Parameters</div>
                </div>

                <div className="pw-comp-row pw-margin-top-1">
                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Theoretical Mass</div>
                        <NumberBox id="theoreticalMass" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="theoretical mass"
                            value={calculator && calculator.theoreticalMass ?
                                calculator.theoreticalMass : undefined} />
                    </div>

                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Actual Mass</div>
                        <NumberBox id="actualMass" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="actual mass"
                            value={calculator && calculator.actualMass ?
                                calculator.actualMass : undefined} />
                    </div>

                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Target Label</div>
                        <NumberBox id="targetLabel"
                            className="textbox"
                            onValueChanged={onValueChanged}
                            value={calculator && calculator.targetLabel ?
                                calculator.targetLabel : undefined}
                            placeholder="# entries" />
                    </div>

                    <div className="pw-row-button-08">
                        <Button id="goBackButton" className="title-bar-button"
                            text="Calculate" icon="formula" type="success"
                            hint="calculate"
                            onClick={calculateHplcMassSpec} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-40">
                        <label className="textbox-label">Area Values</label>
                        <TextBox id="areaValuesString"
                            className="textbox"
                            onValueChanged={onAreaValuesChanged}
                            value={calculator && calculator.areaValuesString ?
                                calculator.areaValuesString : undefined}
                            placeholder="area values" />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">M + 1 (%)</div>
                        <NumberBox id="m1Adjustment" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="na"
                            value={calculator && calculator.m1Adjustment ?
                                calculator.m1Adjustment : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">M + 2 (%)</div>
                        <NumberBox id="m2Adjustment" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="na"
                            value={calculator && calculator.m2Adjustment ?
                                calculator.m2Adjustment : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">M + 3 (%)</div>
                        <NumberBox id="m3Adjustment" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="na"
                            value={calculator && calculator.m3Adjustment ?
                                calculator.m3Adjustment : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">M + 4 (%)</div>
                        <NumberBox id="m4Adjustment" className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder="na"
                            value={calculator && calculator.m4Adjustment ?
                                calculator.m4Adjustment : undefined} />
                    </div>
                </div>


            </div>

            {calculation && calculation.identityByHplcMassSpecResult &&
                <div className="pw-bg-rb-100">
                    <div className="pw-comp-row pw-margin-top-1">
                        <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">Identity by LCMS</div>
                    </div>

                    <div className="pw-comp-row pw-margin-top-1">
                        <div className="pw-form-unit pw-comp-20 pw-margin-bottom-1">
                            <DataGrid height="12rem"
                                width="100%"
                                dataSource={identityResults ?
                                    identityResults : []}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                showRowLines={true}
                                wordWrapEnabled={true}>

                                <Selection mode="none" />

                                <Column dataField='name' width='8rem'
                                    caption="Name" dataType="string" alignment="center" />
                                <Column dataField='value' width='8rem' caption="Value" alignment="center"
                                    cellRender={identityPassFailRender} dataType="number" />

                            </DataGrid>
                        </div>

                        <div>
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label pw-bold">Lower Limit</div>
                                </div>
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label">{calculation.identityByHplcMassSpecResult.lowerLimit ?
                                        calculation.identityByHplcMassSpecResult.lowerLimit : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label pw-bold">Upper Limit</div>
                                </div>
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label">{calculation.identityByHplcMassSpecResult.upperLimit ?
                                        calculation.identityByHplcMassSpecResult.upperLimit : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label">{actualMassPassFail()}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label">{massErrorPassFail()}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {calculation && calculation.hplcMassSpecOverlabeledDistributionResult &&
                <div className="pw-bg-rg-100">
                    <div className="pw-comp-row pw-margin-top-1">
                        <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">{distributionLabel()}</div>
                    </div>

                    <div className="pw-comp-row pw-margin-top-1">
                        <div className="pw-form-unit pw-comp-40 pw-margin-bottom-1">
                            <DataGrid height="100%"
                                width="100%"
                                dataSource={calculation.hplcMassSpecOverlabeledDistributionResult.entries ?
                                    calculation.hplcMassSpecOverlabeledDistributionResult.entries : []}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                showRowLines={true}
                                wordWrapEnabled={true}>

                                <Selection mode="none" />

                                <Column dataField='name' width='12%' cellRender={targetLabelRender}
                                    caption="Name" dataType="string" alignment="center" />
                                <Column dataField='area' width='21%' caption="Area" alignment="center"
                                    dataType="number" />
                                <Column dataField='isotopicPercent' width='21%' caption="Isotopic %" alignment="center"
                                    dataType="number" />

                                {calculation.hplcMassSpecOverlabeledDistributionResult.isOverlabeled &&
                                    <Column dataField='adjustedArea' width='21%' alignment="center"
                                        dataType="number" />
                                }
                                {calculation.hplcMassSpecOverlabeledDistributionResult.isOverlabeled &&
                                    <Column dataField='adjustedIsotopicPercent' width='25%' caption="Adjusted Isotopic %" alignment="center"
                                        dataType="number" />
                                }

                                <Summary>
                                    <TotalItem column="area"
                                        displayFormat="Sum: {0}"
                                        summaryType="sum" />
                                    {calculation.hplcMassSpecOverlabeledDistributionResult.isOverlabeled &&
                                        <TotalItem column="adjustedArea"
                                            displayFormat="Sum: {0}"
                                            summaryType="sum" />
                                    }
                                </Summary>

                            </DataGrid>
                        </div>

                        <div>
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-readonly-label pw-bold">Isotopic %</div>
                                </div>
                                <div className="pw-form-unit pw-comp-10">
                                    <div className="pw-readonly-label">{calculation.hplcMassSpecOverlabeledDistributionResult.isotopicPercent ?
                                        calculation.hplcMassSpecOverlabeledDistributionResult.isotopicPercent : 'NA'}</div>
                                </div>
                            </div>

                            {calculation.hplcMassSpecOverlabeledDistributionResult.isOverlabeled &&
                                <div className="pw-comp-row">
                                    <div className="pw-form-unit pw-comp-15">
                                        <div className="pw-readonly-label pw-bold">Adjusted Isotopic %</div>
                                    </div>
                                    <div className="pw-form-unit pw-comp-10">
                                        <div className="pw-readonly-label">{calculation.hplcMassSpecOverlabeledDistributionResult.adjustedIsotopicPercent ?
                                            calculation.hplcMassSpecOverlabeledDistributionResult.adjustedIsotopicPercent : 'NA'}</div>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            }

            <div className="pw-margin-top-1">
            <HplcCalculationDetails calculation={calculation} calculator={calculator} />
            </div>


            {/*
            {calculation && calculation.htmlCalculationNotes &&
                <div className="pw-margin-top-1">
                    <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">Calculation Notes</div>

                    <HtmlEditor height="30rem"
                        value={calculation.htmlCalculationNotes ? calculation.htmlCalculationNotes : undefined} />
                </div>
            }
            */}

            <DmaFooter />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div >
    );

    function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && calculator) {
            const c = calculator as any;
            const currentValue = c[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    entity: "HplcMassSpecCalculators",
                    rowId: calculatorId,
                    field: caller,
                    value: e.value
                };

                updateCalculatorField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Calculator Field");
                    })
            }
        }

        setCalculator({ ...calculator, [caller]: e.value });
    }

    function onAreaValuesChanged(e: any) {
        if (!dataLoaded)
            return;

        if (calculator) {
            if (calculator.areaValuesString === e.value)
                return;
            else if (!calculator.areaValuesString && !e.value)
                return;
            else {
                updateCalculatorAreas(e.value)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Calculator Areas");
                    })
            }

            setCalculator({ ...calculator, areaValuesString: e.value });
        }
    }

    function updateAreaValuesArray() {
        if (calculator && calculator.areaValuesString) {
            let areaValuesStrings = calculator.areaValuesString.split(",");

            let areaValues: number[] = [];

            for (let areaValueString of areaValuesStrings) {
                areaValues.push(parseFloat(areaValueString));
            }


            console.log("areaValues...");
            console.log(areaValues);


            setCalculator({ ...calculator, areaValues: areaValues });
        }
    }

    function assembleHplcCalculationResults() {
        if (calculator && calculation) {
            if (calculation.identityByHplcMassSpecResult) {
                const identityResults = calculation.identityByHplcMassSpecResult;

                let identResults: NameNumericalValue[] = [];
                identResults.push({ name: "Theoretical Mass", value: calculator.theoreticalMass });
                identResults.push({ name: "+2", value: identityResults.theoreticalMassPlus2 });
                identResults.push({ name: "+3", value: identityResults.theoreticalMassPlus3 });
                identResults.push({ name: "Actual Mass", value: calculator.actualMass });
                identResults.push({ name: "Difference", value: identityResults.actualMassDifference });
                identResults.push({ name: "Mass Error", value: identityResults.actualMassError });

                console.log("formatted data:");
                console.log(identResults);

                setIdentityResults(identResults);
            }
            else if (calculation.hplcMassSpecOverlabeledDistributionResult) {




            }

        }
    }

    async function getHplcMassSpecCalculator() {
        if (calculatorId) {
            console.log("Getting the calculator...");
            await CrudFunctions.getData(`calculator/hplcmassspeccalculator/${calculatorId}`)
                .then((data) => {
                    console.log("HPLC Mass Spec Calc:");
                    console.log(data);

                    /*
                    var hplcCalculator = data as HplcMassSpecCalculator;

                    if (hplcCalculator && !hplcCalculator.createTimestamp) {
                        //no calculator found - open New Dialog
                        showHplcCalculatorDialog();
                    }
                    else
                    */
                    setCalculator(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving HPLC Mass Spec Calculator");
                });
        }
    }

    async function insertHplcMassSpecCalculator(newCalculator: HplcMassSpecCalculator) {
        if (newCalculator) {
            await CrudFunctions.postData("calculator/hplcmassspeccalculator", newCalculator)
                .then((data) => {
                    //console.log("HPLC Mass Spec Calc:");
                    //console.log(data);

                    setCalculator(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Inserting New HPLC Mass Spec Calculator");
                });
        }
    }

    async function updateCalculatorField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("calculator/hplcmassspeccalculatorfield", fieldUpdate);
    }

    async function updateCalculatorAreas(areaValuesString) {
        return await CrudFunctions.putData(`calculator/hplcmassspeccalculatorareas/${calculatorId}`, areaValuesString);
    }

    async function getAllData() {
        await getHplcMassSpecCalculator()
            .then(() => setDataLoaded(true));
    }

    async function calculateHplcMassSpec() {
        if (!calculator) {
            showInformationMessage(ModalMessageType.Warning, "Insufficient Data", "No calculator defined");
            return;
        }
        if (!calculator.theoreticalMass) {
            showInformationMessage(ModalMessageType.Warning, "Insufficient Data", "No Theoretical Mass defined");
            return;
        }
        if (!calculator.actualMass) {
            showInformationMessage(ModalMessageType.Warning, "Insufficient Data", "No Actual Mass defined");
            return;
        }
        if (!calculator.targetLabel) {
            showInformationMessage(ModalMessageType.Warning, "Insufficient Data", "Target Label is not defined");
            return;
        }
        if (!calculator.areaValuesString) {
            showInformationMessage(ModalMessageType.Warning, "Insufficient Data", "No Areas defined");
            return;
        }

        await CrudFunctions.postData("calculator/calculatehplcmassspec", calculator)
            .then((data) => {
                console.log("Identity by HPLC Mass Spec:");
                console.log(data);

                setCalculation(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Calculating HPLC Mass Spec");
            });
    }

    /*
    async function calculateHplcMassSpecOverlabeledDistribution() {
        let request: HplcMassSpecOverlabeledDistributionRequest =
        {
            rawAreas: [3, 3, 0, 0, 2, 4, 3, 18, 874, 85927, 10113, 1130],
            m1Adjustment: 0.1173,
            m2Adjustment: 0.0124

        };

        await CrudFunctions.postData("calculator/calculatehplcmassspecoverlabeleddistribution", request)
            .then((data) => {
                console.log("Identity by HPLC Mass Spec Overlabeled:");
                console.log(data);

                setHplcMassSpecOverlabeledDistribution(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Calculating HPLC Mass Spec");
            });
    }
    */

    function goBack() {
        history.back();
    }


    function targetLabelRender(e: any) {
        console.log("targetLabelRender():");
        console.log(e);

        if (e.data && e.data.isTargetLabel)
            return <div className="pw-bold">{e.value}</div>;

        return <div>{e.value}</div>;
    }


    function identityPassFailRender(e: any) {
        console.log(e);


        return <div>{e.value}</div>;
    }

    function showInformationMessage(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
